<app-rewards-earning-summary-table
  [columns]="columns"
  [items]="items"
  [loading]="loading">
</app-rewards-earning-summary-table>
